// // src/hooks/useQuestions.js
// import { useMemo } from 'react';
// import categories from '../constants/categories';

// export const useQuestions = (currentCategoryId) => {
//   return useMemo(() => {
//     const commonQuestions = categories
//       .filter(cat => cat.category_id === "CM00" || cat.category_id === "CM99")
//       .flatMap(cat => cat.questions);
    
//     const currentCategory = categories.find(cat => cat.category_id === currentCategoryId);
//     return [...(currentCategory?.questions || []), ...commonQuestions];
//   }, [currentCategoryId]);
// };

// src/hooks/useQuestions.js - KEEP AS IS
import { useMemo } from 'react';
import categories from '../constants/categories';

export const useQuestions = (currentCategoryId) => {
  return useMemo(() => {
    const commonQuestions = categories
      .filter(cat => cat.category_id === "CM00" || cat.category_id === "CM99")
      .flatMap(cat => cat.questions);
    
    const currentCategory = categories.find(cat => cat.category_id === currentCategoryId);
    return [...(currentCategory?.questions || []), ...commonQuestions];
  }, [currentCategoryId]);
};